<template>
  <div class="dynamic-detail-body">
    <div style="height: 113px">
      <div class="dynamic-head-box" :class="{ 'scroll-head': scrollShow }">
        <div>
          <p style="margin-top: 0">{{ scenesDetail.sceneName }}</p>
          <div class="dynamic-head-fx">
            <p>
              <span>发布单位：{{ scenesDetail.publisher }}</span>
              <span
                >发布时间：{{
                  scenesDetail.publishTime | moment("YYYY-MM-DD")
                }}</span
              >
              <span>场景来源：{{ scenesDetail.sceneFrom }}</span>
            </p>
            <div>
              分享至：
              <span @click="share('qzone')"
                ><img src="@/assets/img/fxkj.png"
              /></span>
              <span @click="share('qq')"
                ><img src="@/assets/img/fxqq.png"
              /></span>
              <span @click="share('db')"
                ><img src="@/assets/img/db.png"
              /></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="more-dynamic-detail-content-body">
      <div class="more-dynamic-content-left-body">
        <div class="knowledge-scenes-info-descriptions">
          <a-descriptions :title="false" bordered :column="2" size="small">
            <a-descriptions-item label="场景领域">{{
              scenesDetail.fieldName
            }}</a-descriptions-item>
            <a-descriptions-item label="应用行业">{{
              scenesDetail.industryName
            }}</a-descriptions-item>
            <a-descriptions-item label="技术类别">{{
              scenesDetail.skillName
            }}</a-descriptions-item>
            <a-descriptions-item label="城市"></a-descriptions-item>
            <a-descriptions-item label="联系人">{{
              scenesDetail.contactPerson
            }}</a-descriptions-item>
            <a-descriptions-item label="联系电话">{{
              scenesDetail.contactDetail
            }}</a-descriptions-item>
            <a-descriptions-item label="关键词">{{
              scenesDetail.sceneKeywords
            }}</a-descriptions-item>
            <a-descriptions-item label="产业生态"></a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="more-dynamic-detail-content">
          <p class="knowledge-scenes-info-title"><span>应用场景简介</span></p>
          <div class="ql-container ql-snow">
            <div
              class="more-dynamic-detail-content-text ql-editor"
              v-html="scenesDetail.description"
            ></div>
          </div>
        </div>
      </div>
      <div class="more-dynamic-right-body">
        <span @click="noUrl"><img src="@/assets/img/ggimg.jpg" /></span>
        <div>
          <div class="more-dynamic-title">
            <p>其他推荐</p>
          </div>
          <div class="more-dynamic-list">
            <div
              v-for="item in scenesList"
              :key="item.id"
              @click="sceneSubInfo(item.id)"
            >
              <p>{{ item.sceneName }}</p>
              <div>
                <span>{{ item.publishTime | moment("YYYY-MM-DD") }} 发布</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getZsyInfo, getRecommends } from "@/api/zsy";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      scrollShow: false,
      scenesId: "",
      scenesDetail: "",
      scenesList: [],
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.scenesId = to.query.id;
        this.scenesInfo();
        this.loadSubZsyList();
      },
      deep: true,
    },
  },
  computed: mapGetters(["userInfo"]),
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.scenesId = this.$route.query.id;
    this.scenesInfo();
    this.loadSubZsyList();
  },
  methods: {
    noUrl() {
      this.$message.warning("暂无跳转链接！");
    },
    scenesInfo() {
      getZsyInfo(this.scenesId).then((res) => {
        this.scenesDetail = res.data;
      });
    },
    loadSubZsyList() {
      let page = {
        current: 1,
        size: 5,
      };
      getRecommends(page, this.scenesId).then((res) => {
        this.scenesList = res.data.records;
      });
    },
    sceneSubInfo(id) {
      this.$router.push({
        path: "/homeKnowledge/scenesInfo",
        query: { id },
      });
    },
    handleScroll() {
      if (document.documentElement.scrollTop > 210) {
        this.scrollShow = true;
      } else {
        this.scrollShow = false;
      }
    },
    share(type) {
      let newDetail = this.scenesDetail;
      //qq空间分享接口
      if (type == "qzone") {
        window.open(
          `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=` +
            window.location.href
        );
      }
      //qq好友接口的传参
      if (type == "qq") {
        window.open(
          `http://connect.qq.com/widget/shareqq/index.html?url=` +
            encodeURIComponent(window.location.href) +
            `?sharesource=qzone&title=${newDetail.sceneName}&pics=图片地址&summary=''`
        );
      }
      if (type == "db") {
        window.open(
          `http://shuo.douban.com/!service/share?href=` +
            encodeURIComponent(window.location.href) +
            `&name=${newDetail.sceneName}&text=''&image=图片地址&starid=0&aid=0&style=11`
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.dynamic-detail-body {
  padding-bottom: 40px;
}
.knowledge-scenes-info-descriptions {
  padding: 24px;
  background: #fff;
  margin-bottom: 24px;
}
.knowledge-scenes-info-title {
  position: relative;
  display: flex;
  margin-bottom: 24px;
  > span {
    font-size: 16px;
    color: #262626;
    line-height: 16px;
    position: relative;
    z-index: 2;
    font-weight: bold;
  }
  &::after {
    content: "";
    position: absolute;
    width: 96px;
    height: 8px;
    background: #1abc9c;
    left: 0;
    bottom: -4px;
    z-index: 1;
  }
}
.dynamic-head-box {
  background: #fff;
  > div {
    width: 1200px;
    margin: 0 auto;
    padding: 24px 0;
    > p {
      font-size: 24px;
      line-height: 24px;
      margin: 20px 0;
    }
    .dynamic-head-fx {
      display: flex;
      align-items: center;
      justify-content: space-between;
      > p {
        font-size: 12px;
        display: flex;
        color: #8c8c8c;
        > span {
          margin-right: 24px;
          line-height: 12px;
        }
      }
      > div {
        display: flex;
        align-items: center;
        > span {
          margin-left: 6px;
          cursor: pointer;
          > img {
            display: block;
          }
        }
      }
    }
  }
}
.more-dynamic-detail-content-body {
  display: flex;
  width: 1200px;
  margin: 24px auto 0;
  .more-dynamic-content-left-body {
    flex: 1;
    .more-dynamic-detail-content {
      background: #fff;
      padding: 30px;
      .more-dynamic-detail-content-text {
        line-height: 26px;
        padding-bottom: 60px;
        padding: 0;
      }
      .more-dynamic-detail-content-annex {
        margin-top: 24px;
        > p {
          font-size: 16px;
          line-height: 16px;
          position: relative;
          margin-bottom: 36px;
          > span {
            display: block;
            line-height: 16px;
            position: relative;
            z-index: 2;
          }
          &::after {
            content: "";
            position: absolute;
            width: 64px;
            height: 8px;
            background: #1abc9c;
            left: 0;
            bottom: -4px;
          }
        }
        > div {
          > div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 32px;
            padding: 0 16px;
            margin-bottom: 16px;
            cursor: pointer;
            &:last-child {
              margin-bottom: 0;
            }
            > div {
              display: flex;
              align-items: center;
              > img {
                margin-right: 8px;
              }
              > p {
                max-width: 400px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            > span {
              color: #1abc9c;
              cursor: pointer;
              display: none;
            }
            &:hover {
              background: #f5f5f5;
              > span {
                display: block;
              }
            }
          }
        }
      }
    }
    .dynamic-up-down {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 24px 0 60px;
      > p {
        display: flex;
        > span {
          color: #1abc9c;
          cursor: pointer;
          max-width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .more-dynamic-right-body {
    width: 280px;
    margin-left: 24px;
    > span {
      display: block;
      cursor: pointer;
      margin-bottom: 24px;
      > img {
        display: block;
      }
    }
    > div {
      background: #fff;
      .more-dynamic-title {
        height: 48px;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        > p {
          font-size: 16px;
        }
        > span {
          font-size: 12px;
          color: #8c8c8c;
          cursor: pointer;
        }
      }
      .more-dynamic-list {
        padding: 0 16px;
        > div {
          border-bottom: 1px solid #f0f0f0;
          padding: 16px 0;
          cursor: pointer;
          > p {
            line-height: 14px;
            margin-bottom: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          > div {
            display: flex;
            > span {
              margin-right: 16px;
              font-size: 12px;
              line-height: 12px;
              color: #8c8c8c;
            }
          }
          &:last-child {
            border-bottom: 0;
          }
        }
      }
    }
  }
}
.scroll-head {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.08);
  > div {
    > p {
      margin-top: 0;
    }
  }
}
</style>
<style>
.ant-page-header.has-breadcrumb {
  padding: 0;
  line-height: 14px;
}
.ant-page-header.has-breadcrumb a:hover {
  color: #1abc9c;
}
.before-content-body {
  background: #f7f7f7;
}
.more-dynamic-detail-content .ql-container.ql-snow {
  border: none;
}
</style>
